import React, { Component } from 'react';
import { connect } from "react-redux";
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { SetLoginOTP } from '$Deposits/store/actions/DepositAction'

class OtpPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {

    }
    componentWillUnmount() {
        
    }


    render() {
        const { goVerifyContact } = GetParamsData()

        const {
            Modal,
            LoginOTP,
            SetLoginOTP,
            MemberInfo,
        } = this.props
        
        return (
            <>
                <Modal
                    modalVisible={LoginOTP}
                    title={'isLoginOTP'}
                    okText={'isLoginOTP'}
                    msg={`去验证`}
                    onChange={() => { 
                        SetLoginOTP()
                        goVerifyContact(MemberInfo)
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    Announcement: state.Announcement,
    LoginOTP: state.LoginOTP,
    MemberInfo: state.MemberInfo,
});
const mapDispatchToProps = {
    SetLoginOTP: () => SetLoginOTP(),

};
export default connect(mapStateToProps, mapDispatchToProps)(OtpPopup);
